import { saveAuth } from './index.js'
import { completeCreatorHubCanonicalCallback } from './canonical-client.js'

/**
 * Complete the canonical customer authorization-code callback. Always live
 * (H-2026-10-16-175 removed the flag gating) — main.js routes
 * /auth/callback boots here before anything else.
 */
export async function handleCreatorHubAuthCallback(
  search = typeof window === 'undefined' ? '' : window.location.search,
  fetcher = fetch
) {
  const result = await completeCreatorHubCanonicalCallback(search, fetcher)
  if (result.ok) saveAuth(result.customer, localStorage.getItem('mms_customer_token'))
  return result
}

export {
  CREATOR_HUB_CANONICAL_CLIENT_ID,
  CREATOR_HUB_CANONICAL_REDIRECT_URI,
} from './canonical-client.js'
